export default __webpack_public_path__ + "static/media/071-rat.330ec9f1.svg";